import React from "react";

import HomeIcon from "@material-ui/icons/Home";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import LiveTvIcon from "@material-ui/icons/LiveTv";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import SearchIcon from "@material-ui/icons/Search";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";

import "./Header.css";
function Header() {
    return (
        <div className="header">
            <div className="header__icons">
                <div className="header__icon header__icon--active">
                    <HomeIcon />
                    <p>Home</p>
                </div>
                <div className="header__icon">
                    <FlashOnIcon />
                    <p>trending</p>
                </div>
                <div className="header__icon">
                    <LiveTvIcon />
                    <p>verified</p>
                </div>
                <div className="header__icon">
                    <VideoLibraryIcon />
                    <p>collections</p>
                </div>
                <div className="header__icon">
                    <SearchIcon />
                    <p>search</p>
                </div>
                <div className="header__icon">
                    <PersonOutlineIcon />
                    <p>account</p>
                </div>
            </div>
            <img src="http://press.hulu.com/uploads/wp-content/uploads/2020/02/hulu-white.png" />
        </div>
    );
}

export default Header;
